import { render, staticRenderFns } from "./MobileButton.vue?vue&type=template&id=43aa87de&"
import script from "./MobileButton.vue?vue&type=script&lang=ts&"
export * from "./MobileButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports